import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Filter, CosmeticOptions } from '../models/filter-models';
import { Rarity, Comparator, MinimapIconShape, MinimapIconSize, Color, LabelSize } from "../models/enums";
import { FormsModule } from '@angular/forms';
import { ItemDataService } from '../services/item-data.service';
import { BaseType, ItemData, Tier } from '../models/item-data-models';
import { TierCosmeticsComponent } from './tier-cosmetics/tier-cosmetics.component';
import { FilterTitleComponent } from '../common/filter-title/filter-title.component';
import { FilterService } from '../services/filter.service';
import { CosmeticPresetsComponent } from './cosmetic-presets/cosmetic-presets.component';
import { SelectMinimapIconComponent } from '../common/select/select-minimap-icon/select-minimap-icon.component';
import { BaseComponent } from '../common/base.component';
import { ItemTypeOverrideCosmeticsComponent } from './item-type-override-cosmetics/item-type-override-cosmetics.component';
import { LabelViewerComponent } from '../common/label-viewer/label-viewer.component';
import { CosmeticControls } from './cosmetic-controls.model';
import { CosmeticSettingsComponent } from './cosmetic-settings/cosmetic-settings.component';
import { DynamicContentComponent } from '../common/dynamic-content/dynamic-content.component';
import { CustomRuleGroupsListComponent } from '../common/custom-rules/custom-rule-groups-list/custom-rule-groups-list.component';
import { CustomRuleGroupsTabController } from '../common/custom-rules/custom-rule-groups-tab.controller';

@Component({
  selector: 'app-cosmetic-tab',
  templateUrl: './cosmetic-tab.component.html',
  styleUrl: './cosmetic-tab.component.scss',
  imports: [FormsModule, TierCosmeticsComponent, FilterTitleComponent, CosmeticPresetsComponent, SelectMinimapIconComponent,
    ItemTypeOverrideCosmeticsComponent, LabelViewerComponent, CosmeticSettingsComponent, DynamicContentComponent,
    CustomRuleGroupsListComponent]
})
export class CosmeticTabComponent extends BaseComponent implements OnInit, OnChanges {
  @Input({ required: true }) filter!: Filter;

  groupsCtrl!: CustomRuleGroupsTabController;

  Rarity = Rarity;
  Comparator = Comparator;
  MinimapIconShape = MinimapIconShape;
  MinimapIconSize = MinimapIconSize;
  Color = Color;
  LabelSize = LabelSize;
  Tier = Tier;

  itemData!: ItemData[];
  cheapCurrencyWithImages: BaseType[];

  customDropTierStyles = true;

  showCosmeticPresetsDialog = false;

  divinationCardCosmeticControls = new CosmeticControls();
  equipmentCosmeticControls = new CosmeticControls();

  dropTierTab: dropTierTabType = 'currency';

  constructor(private itemDataService: ItemDataService, private filterService: FilterService) {
    super();
    this.itemData = this.itemDataService.getItemData();

    this.cheapCurrencyWithImages = this.itemDataService.getFlatItemData()
      .filter(i => itemDataService.getCheapCurrency().includes(i.baseType.name))
      .map(i => ({ name: i.baseType.name, image: i.baseType.image }));
  }

  ngOnInit(): void {
    const initialUrl = window.location.pathname.split('/')[2];
    this.dropTierTab = initialUrl as any || 'currency';
    this.initGroupsCtrl();
    this.refreshGroupsUiState();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filter']) {
      this.initGroupsCtrl();
      this.refreshGroupsUiState();
    }
  }

  private initGroupsCtrl(): void {
    this.groupsCtrl = new CustomRuleGroupsTabController(
      () => this.filter.customCosmeticRuleGroups,
      () => this.filter,
      () => this.filterService.updateFilter(),
      'Custom Cosmetic Rule Group',
    );
  }

  refreshGroupsUiState(): void {
    this.groupsCtrl.refreshUiState();
  }

  openCosmeticPresetsDialog = () => {
    this.showCosmeticPresetsDialog = true;
  }

  updateFilter() {
    this.groupsCtrl.updateFilter();
  }

  playSound(sound: string | null) {
    if (!sound) return;
    const audio = new Audio();
    audio.src = `/sounds/sound${sound}.mp3`;
    audio.load();
    audio.play();
  }

  hideContinueWarning() {
    this.settings.dismissContinueWarning();
  }

  selectTab(dropTierTab: dropTierTabType) {
    this.dropTierTab = dropTierTab;

    window.history.replaceState({}, '', `/cosmetic/${dropTierTab}`);
  }

  toggleDivCardMinimapIconShape() {
    if (!this.filter.divCardCosmeticsSameAsTierCosmeticsOverrides.displayOptions.cosmeticOptions) {
      this.filter.divCardCosmeticsSameAsTierCosmeticsOverrides.displayOptions.cosmeticOptions = new CosmeticOptions();
    }

    if (!this.filter.divCardCosmeticsSameAsTierCosmeticsOverrides.displayOptions.cosmeticOptions.minimapIconShape) {
      this.filter.divCardCosmeticsSameAsTierCosmeticsOverrides.displayOptions.cosmeticOptions.minimapIconShape = MinimapIconShape.Square;
    }

    this.updateFilter();
  }

  toggleEquipmentMinimapIconShape() {
    if (!this.filter.equipmentCosmeticsSameAsTierCosmeticsOverrides.displayOptions.cosmeticOptions) {
      this.filter.equipmentCosmeticsSameAsTierCosmeticsOverrides.displayOptions.cosmeticOptions = new CosmeticOptions();
    }

    if (!this.filter.equipmentCosmeticsSameAsTierCosmeticsOverrides.displayOptions.cosmeticOptions.minimapIconShape) {
      this.filter.equipmentCosmeticsSameAsTierCosmeticsOverrides.displayOptions.cosmeticOptions.minimapIconShape = MinimapIconShape.Kite;
    }

    this.updateFilter();
  }
}

type dropTierTabType = 'currency' | 'divination-cards' | 'uniques' | 'chance-bases' | 'items';
